// extracted by mini-css-extract-plugin
module.exports = {"moreInfo":"wV","link":"wW","linkText":"wX","linkIcon":"wY","isRental":"wZ","active":"w0","synopsisAndButton":"w1","linkWrapper":"w2"};